/** Quotes module — domain types (Sprint 0.4) */

export type QuoteStatus =
  | 'DRAFT'
  | 'SENT'
  | 'AWAITING'
  | 'APPROVED'
  | 'LOST'
  | 'CANCELLED'

export type ValidityDays = 3 | 5 | 7 | 15 | 30

export interface QuoteLineItem {
  id: string
  productId: string | null
  description: string
  quantity: number
  purchasePrice: number
  operational: number
  taxes: number
  profit: number
  salePrice: number
  subtotal: number
  sortOrder: number
}

export interface QuoteTotals {
  itemsCount: number
  purchaseTotal: number
  subtotal: number
  discount: number
  freight: number
  total: number
  profitTotal: number
  margin: number
}

export interface QuoteDocument {
  id: string
  code: string
  title: string | null
  status: QuoteStatus
  customerId: string | null
  customerName: string | null
  validUntilDays: ValidityDays
  quoteDate: string
  discountPercent: number
  discountValue: number
  freight: number
  notes: string
  items: QuoteLineItem[]
  totals: QuoteTotals
  // Future integrations (stubs)
  snapshotJson: string | null
  pdfUrl: string | null
  createdAt: string
  updatedAt: string
}

export const QUOTE_STATUS_LABELS: Record<QuoteStatus, string> = {
  DRAFT: 'Rascunho',
  SENT: 'Enviado',
  AWAITING: 'Aguardando',
  APPROVED: 'Aprovado',
  LOST: 'Perdido',
  CANCELLED: 'Cancelado',
}

export const VALIDITY_OPTIONS: ValidityDays[] = [3, 5, 7, 15, 30]

export const QUOTE_LIBRARY_CATEGORIES = [
  'Notebook',
  'Desktop',
  'Servidor',
  'SSD',
  'HD',
  'NVMe',
  'Memória',
  'Fonte',
  'Processador',
  'Cooler',
  'Placa Mãe',
  'Placa de Vídeo',
  'Gabinete',
  'Monitor',
  'Mouse',
  'Teclado',
  'Office',
  'Windows',
  'Backup',
  'Formatação',
  'Limpeza',
  'Mão de Obra',
  'Outros',
] as const

export type QuoteLibraryCategory = (typeof QUOTE_LIBRARY_CATEGORIES)[number]
